import moment from 'moment';
import React, {useState} from 'react'
import {v3_add_inspection_comment, v3_delete_inspection_attendance} from '../../../actions/v3/inspection';
import {validateFunctionalForm, getLoggedInUserId, getLoggedInUserRoleId} from '../../../utils';
import {toast} from 'react-toastify';
import AttendanceForm from './attendanceForm';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';

const statusClassMap = {
    'Accepted': 'accpt',
    'Passed': 'passd',
    'Scheduled': 'sched',
    'In Progress': 'in-progress',
    'Unscheduled': 'unscheduled-ins',
    'Cancelled': 'cncld'
};

const getValidAttendanceDocuments = (documents = []) => (
    Array.isArray(documents)
        ? documents.filter((doc) => doc?.FILE_NAME || doc?.fileName)
        : []
);

const getInspectionCommentCount = (item = {}) => {
    const apiCount = item.TOTAL_COMMENTS ?? item.COMMENT_COUNT;
    if (apiCount !== undefined && apiCount !== null) {
        const parsedCount = Number(apiCount);
        if (Number.isFinite(parsedCount)) return parsedCount;
    }

    if (Array.isArray(item.attendance)) return item.attendance.length;
    if (Array.isArray(item.comments)) return item.comments.length;
    return 0;
};

const InspectionDetail = ({data, setRefresh, refresh}) => {
    const [state, setState] = useState({
        comment: {name: 'comment', value: '', isRequired: true, error: ''},
    })
    const [attendenceData, setAttendenceData] = useState({})
    const visibleCommentsCount = getInspectionCommentCount(data);
    const loggedInUserId = getLoggedInUserId();
    const loggedInUserRoleId = getLoggedInUserRoleId();

    const handleDeleteAttendance = (attendanceId) => {
        if (window.confirm("Are you sure you want to delete this comment?")) {
            v3_delete_inspection_attendance(attendanceId)
                .then((res) => {
                    if (res.status) {
                        toast.success(res.result?.message || 'Comment deleted successfully');
                        setRefresh(!refresh);
                    } else {
                        toast.error(res.result?.message || 'Failed to delete comment');
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error('Something went wrong while deleting comment');
                });
        }
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setState((prev) => ({
            ...prev,
            [name]: {...prev[name], value},
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                comment: state.comment.value,
                inspectionId: data.ID
            }
            v3_add_inspection_comment(model).then((res) => {
                if (res.status) {
                    toast.success(res.result.message)
                    setRefresh(!refresh)
                    setState((prev) => ({
                        ...prev,
                        ['comment']: {...prev['comment'], value: ''},
                    }));
                }
            })
        }
    }

    console.log(attendenceData)

    return (

        <div className="inspection-left-section">
            <div className="inspection-item-details">
                <div className="inspection-name">
                    <h4>{data.INSPECTION_NAME}</h4>
                    <div className="inspection-status">
                        <ul>

                            <li className={statusClassMap[data.STATUS] || ''}>
                                {data.STATUS}
                            </li>
                            {/* <li className="status">
                                Current Revision <span className="bdg">24</span>
                            </li> */}
                            <li className="status">
                                Comments <span className="bdg">{visibleCommentsCount}</span>
                            </li>
                            <li className="status">
                                Location : {data.LOCATION_NAME}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="about-inspection-info">
                    <div className="insp-info-item">
                        <h5>Hull</h5>
                        <p>{data.HULL_NUMBER} - {data.SHIP_NAME}</p>
                    </div>
                    <div className="insp-info-item">
                        <h5>Category</h5>
                        <p>{data.CATEGORY_NAME}</p>
                    </div>
                    <div className="insp-info-item">
                        <h5>Assignee</h5>

                        <p>{data.ASSIGNEE_NAME}</p>
                    </div>
                    <div className="insp-info-item">
                        <h5>Scheduled Date</h5>
                        <p>{data.SCHEDULE_DATE ? moment(data.SCHEDULE_DATE).format('MMM DD YYYY') : ''}</p>
                    </div>
                    {/* <div className="insp-info-item">
                        <h5>Passed Date</h5>
                        <p>{data.PASSED_BY ? moment(data.PASSED_DATE).format('MMM DD YYYY') + ' by ' + data.PASSED_BY_NAME : ''}</p>
                    </div> */}
                    <div className="insp-info-item">
                        <h5>Accepted Date</h5>
                        <p>{data.ACCEPTED_DATE ? moment(data.ACCEPTED_DATE).format('MMM DD YYYY') : ''}</p>
                    </div>
                </div>
                <div
                    className="inspection-table-info"
                >
                    <div className="inspection-title-box">
                        <div className="inspection-one">Comment</div>
                        <div className="inspection-two">
                            <button
                                className="btn btn-sm btn-primary me-2"
                                style={{
                                    backgroundImage:
                                        "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                }}
                                data-bs-toggle="modal"
                                data-bs-target={`#newAttendanceModal`}
                            >
                                <i className="fa fa-plus-circle me-1"/>
                                Create New Comment
                            </button>
                        </div>
                    </div>
                    <div
                        className="modal fade"
                        id={`newAttendanceModal`}
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="newAttendanceModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="newAttendanceModalLabel">
                                        Add Comment
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <AttendanceForm
                                        data={data}
                                        setRefresh={setRefresh}
                                        refresh={refresh}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal fade"
                        id={`newAttendanceModalEdit`}
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="newAttendanceModalEditLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="newAttendanceModalEditLabel">
                                        Edit Comment
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <AttendanceForm
                                        data={data}
                                        setRefresh={setRefresh}
                                        refresh={refresh}
                                        attendenceData={attendenceData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="appraisal-report-table-responsive">
                        <table className="plan-approval-table inspection-approval-table">
                            <thead>
                            <tr>
                                <th>Comment</th>
                                <th>Files</th>
                                <th>Inspection Date</th>
                                <th>Created By</th>
                                <th className="">Result</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(data?.attendance || []).map((item, index) => {
                                const validDocuments = getValidAttendanceDocuments(item.documents);
                                return (
                                    <tr>
                                        <td>
                                            <p className="s1">
                                                {/* <a href="">{index + 1}</a> */}
                                                {item.REMARK}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <span className="d-flex">
                                                    <div className="dropdown hover-dropdown">
                                                        <span
                                                            className="file-down dropdown-toggle"
                                                            role="button"
                                                        >
                                                            Files {validDocuments.length} <i className="bx bx-download"/>
                                                        </span>
                                                        <FileDropdownPreviewMenu
                                                            files={validDocuments.map((doc, docIndex) => {
                                                                const rawFileName = doc.FILE_NAME || doc.fileName || '';
                                                                const encodedFileName = encodeURIComponent(rawFileName);
                                                                const displayName = doc.ORIGINAL_FILE_NAME || doc.originalFileName || rawFileName || `File ${docIndex + 1}`;
                                                                return {
                                                                    id: `${item.ID}-${rawFileName || 'file'}-${docIndex}`,
                                                                    name: displayName,
                                                                    previewUrl: rawFileName
                                                                        ? `${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/preview/${data.ID}/${item.ID}/${encodedFileName}`
                                                                        : '',
                                                                    downloadUrl: rawFileName
                                                                        ? `${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/download/${data.ID}/${item.ID}/${encodedFileName}`
                                                                        : '',
                                                                };
                                                            })}
                                                            onDownloadAll={validDocuments.length ? () => {
                                                                window.open(`${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/download/${data.ID}/${item.ID}`, '_blank', 'noopener,noreferrer');
                                                            } : null}
                                                        />
                                                    </div>
                                                <i
                                                    className="bx bx-edit"
                                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                                    onClick={() => setAttendenceData(item)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#newAttendanceModalEdit"
                                                    title="Edit files"
                                                />
                                                </span>
                                            </p>
                                        </td>
                                        <td>
                                            <p className="s1">{moment(item.INSPECTION_DATE).format('MMM DD YYYY')}</p>

                                        </td>
                                        <td>
                                            <p className="s1">{item.ATTENDED_BY_NAME}</p>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-row align-items-center justify-content-center">
                                                <p className="s1 mb-0 me-2">{item.RESULT}</p>
                                                <i
                                                    className="bx bx-edit text-primary"
                                                    style={{cursor: 'pointer', fontSize: '18px', marginRight: '8px'}}
                                                    onClick={() => {
                                                        setAttendenceData(item)
                                                    }}
                                                    data-bs-toggle="modal"
                                                    data-bs-target={`#newAttendanceModalEdit`}
                                                    title="Edit Comment"
                                                />
                                                {(String(item.CREATED_BY) === String(loggedInUserId) || 
                                                  String(item.ATTENDED_BY) === String(loggedInUserId) || 
                                                  String(loggedInUserRoleId) === '1') && (
                                                    <i
                                                        className="bx bx-trash text-danger"
                                                        style={{cursor: 'pointer', fontSize: '18px'}}
                                                        onClick={() => handleDeleteAttendance(item.ID)}
                                                        title="Delete Comment"
                                                    />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}


                            </tbody>
                        </table>

                    </div>
                    {/* {data.comments?.map((comment, idx) => (
                        <div key={idx} className='CommentBox'>
                            <p>{comment.COMMENT}</p>
                            <h5>Commented By: <span>{comment.COMMENTED_BY_NAME}</span></h5>
                            <h5>Date: <span>{moment(comment.CREATED_ON).format('DD MMM, YYYY')}</span></h5>

                        </div>


                    ))} */}
                </div>
                {/* <div className="add-comments-section">
                    <div className="comments-add-box">
                        <div className="inputbox">
                            <label>Add Comment</label>
                            <textarea
                                value={state.comment.value}
                                name={state.comment.name}
                                onChange={handleChange}
                            />
                            <button type="button" onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default InspectionDetail
